import React from "react";
import { Link } from "react-router-dom";

export default function Industries() {
    return (
        <section id="industries-section" className="relative bg-black pt-20 pb-20">
            <div className="relative z-10 grid grid-cols-1 gap-4 xl-custom:grid-cols-12 mx-auto max-w-6xl px-4 sm:px-6">

                <div className="w-full py-12 text-white text-left order-2 xl-custom:order-1 col-span-1 xl-custom:col-span-5">
                    <h2 className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px] xl-custom:text-[36px] xl-custom:leading-[44px]">Industries</h2>
                    <p className="mt-2 text-current font-uber text-[16px] font-normal leading-[24px]">
                        Immersive ad experiences crafted for multiple industries — including Food & Beverages, Healthcare, Entertainment, and more.
                    </p>
                    <Link
                        to="/industries"
                        className="mt-4 xl-custom:mt-8 px-6 py-2 bg-white text-black rounded active:bg-gray-700 active:text-white text-[16px] font-uber font-medium inline-block"
                    >
                        See More
                    </Link>
                </div>

                <div className="w-full p-4 flex justify-center order-1 xl-custom:order-2 col-span-1 xl-custom:col-start-7 xl-custom:col-span-6 relative pb-10">
                    <img
                        src="/uploads/Assets/Asset3.webp"
                        alt="asset3"
                        className="z-10 w-full"
                    />
                    <img
                        src="/uploads/Assets/Industries_mobile_mock.png"
                        alt="Industries_mobile_mock"
                        className="absolute z-20 w-1/2 bottom-0 left-[10%] -ml-10 sm:-ml-20 xl-custom:-ml-40"
                    />
                </div>
            </div>
        </section>
    );
}